<template>
  <div class="conteudoInterno" id="diretor-operacoes">
    <div class="boxSeta">
      <div class="setaScrollstatic" style="" :class="{
        setaScroll: setaScrollState
      }">
        <button><span><i class="bottom"></i></span></button>
      </div>
    </div>
    <header class="headerSec">
      <h2>Our Chief Operating Officer’s Analysis</h2>
      <div class="navSetas">
        <button @click="goBack()" :disabled="clicked"><span><i class="left"></i></span></button>
        <button @click="goNext()" :disabled="clicked"><span><i class="right"></i></span></button>
      </div>
      <!-- <span></span> -->
    </header>
    <div class="conteudoInternoBox">
      <section class="sectionRow">
        <div class="col23ponto5 marginColBottom">
          <span class="linecol ubcBlueBack"></span>
        </div>
      </section>
      <section class="sectionRow top65">
        <div class="col40ponto4">
          <img title="Fábio Geovane" alt="Fábio Geovane" src="../assets/imgs/fabio_geovane.jpg" />

          <h4 class="h4Destaque  ">“The year’s standout achievement was UBC’s record-breaking <span class="sanukBlack ubcBlue">BRL 1 billion in distributions</span>. This represents an 8% increase over the previous year.”</h4>
        </div>
        <div class="col49">

          <p>2025 was another landmark year for UBC. Amid ongoing changes in the music industry and the audiovisual
            content market, we continued to strengthen our role as a leading collective management organization,
            delivering historic results for our members and represented rightsholders.</p>
          <p>The year’s standout achievement was UBC’s record-breaking <span class="sanukBlack ubcBlue">BRL 1 billion in distributions</span>. This represents
            an 8% increase over the previous year and reflects a sustained pattern of growth, as well as the trust that
            creators and rightsholders place in UBC to manage their rights.</p>
          
          <!-- <br /> -->
          <p>The results achieved in 2025 were driven by strong performances across several sectors of the music
            industry, particularly live events, cultural celebrations and digital platforms.</p>
          <p>Among the segments that showed the highest percentage growth within Brazil’s collective management system,
            the following stand out:</p>
          <h4 class="ubcBlue sanukBlack sectionTitle">Carnival</h4>
          <p>Revenue generated through Carnival grew by <span class="sanukBlack ubcBlue">34.83%</span>, underscoring the enduring strength of Brazil's largest
            cultural celebration and its growing contribution to copyright revenues.</p>
          <h4 class="ubcBlue sanukBlack sectionTitle">June Festivals</h4>
          <p>June Festivals posted one of the strongest performances of the year, with growth of <span class="sanukBlack ubcBlue">40.36%</span>. The result
            highlights both the cultural significance and the increasing economic impact of regional festivities across
            Brazil.</p>

          <h4 class="ubcBlue sanukBlack sectionTitle">Live Music and Concerts</h4>
          <p>The live entertainment sector continued its upward trajectory.</p>
          <p>Revenue from <span class="sanukBlack ubcBlue">Live Music</span> increased by <span class="sanukBlack ubcBlue">20.99%</span>, while the <span class="sanukBlack ubcBlue">Live Concerts</span> segment grew by <span class="sanukBlack ubcBlue">15.81%</span> compared with
            the previous year.</p>
          <p>These results reflect the continued strength of the live events ecosystem, supported by the full recovery
            of in-person activities.</p>
          <h4 class="ubcBlue sanukBlack sectionTitle">Video Streaming</h4>
          <p>Video Streaming remained one of the main drivers of digital revenue growth, increasing by <span class="sanukBlack ubcBlue">15.97%</span> compared
            with 2024. The result further confirms the maturity and continued expansion of video-on-demand (VOD)
            platforms.</p>
          <h4 class="ubcBlue sanukBlack sectionTitle">Audio Streaming</h4>
          <p>Audio Streaming also delivered positive results, growing by <span class="sanukBlack ubcBlue">6.99%</span> year over year.</p>
          <p>Taken together, audio and video streaming continue to reinforce the growing importance of digital services
            to the economic sustainability of creators and rightsholders represented by UBC.</p>

          <h4 class="ubcBlue sanukBlack sectionTitle">DIVERSIFICATION OF REVENUE SOURCES</h4>
          <p>Beyond these highlights, UBC recorded growth across nearly all major distribution categories.</p>
          <p>Radio, Free-to-Air Television, Event Venues and Background Music all delivered positive results,
            contributing to a more diversified revenue base and supporting the stability of UBC's distribution model.
          </p>
          <p>Although Pay Television declined slightly, by 0.90%, growth across other categories more than offset this
            result and supported another year of robust overall distribution growth.</p>
          <h4 class="ubcBlue sanukBlack sectionTitle">DIGITAL TRANSFORMATION: NEW WEBSITE AND MEMBER PORTAL</h4>
          <p>In 2025, UBC took another important step in its digital transformation journey with the launch of a new
            institutional website and redesigned member portal.</p>
          <p>The project was developed to provide a more modern, intuitive and efficient experience for members.</p>
          <p>Key improvements include:</p>
          <ul class="listItems">
            <li>Full portal availability in <span class="sanukBlack ubcBlue">three languages</span>, strengthening engagement with international partners and
              rightsholders;</li>
            <li>A redesigned user experience with enhanced accessibility features, including customizable visual
              settings tailored to individual user preferences;</li>
            <li>Migration to a cloud-based infrastructure;</li>
            <li>New dashboards, rankings and reporting tools.</li>
          </ul>
          <p></p>
          <h4 class="ubcBlue sanukBlack sectionTitle">CHIQUINHA: ARTIFICIAL INTELLIGENCE IN SERVICE OF RIGHTSHOLDERS</h4>
          <p>As part of this transformation, UBC launched Chiquinha, its new AI-powered virtual assistant.</p>
          <p><span class="sanukBlack ubcBlue">Chiquinha</span> helps users navigate services, operational procedures and frequently asked questions, providing
            faster access to information and greater autonomy in day-to-day interactions.</p>
          <p>The initiative reflects UBC's ongoing commitment to using innovative technologies to improve the member
            experience and enhance operational efficiency.</p>
            
          <h4 class="ubcBlue sanukBlack sectionTitle">MORE INFORMATION, GREATER TRANSPARENCY AND BETTER INSIGHTS</h4>
          <p>Another major enhancement to the portal was the introduction of new dashboards, reports and interactive
            data visualizations.</p>
          <p>Members now have access to more powerful tools for tracking earnings, analyzing distribution trends,
            identifying revenue sources and gaining a clearer understanding of how monthly distributions are calculated.
          </p>
          <p>This investment reinforces UBC's longstanding commitment to transparency, sound governance and meaningful
            access to information.</p>
          <p>Beyond the portal, UBC continues to develop new systems and technologies to better represent its members in
            Brazil and internationally, working closely with organizations such as CISAC, SCAPR and IFPI.</p>
          <p>We will continue investing in innovation, technology, transparency and operational excellence to ensure
            that the years ahead bring even greater growth and value for the entire music community.</p>

          <br />
          <p class="ubcBlue sanukBold">Fabio Geovane</p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { ShareFunctions } from '../assets/js/functions.js'

export default {
  name: 'AnaliseDiretorDeOperacoes',
  props: ['clicked'],

  data() {
    return {
      setaScrollState: false,
    }
  },
  mounted() {
    const conteudo = document.querySelector('#diretor-operacoes')
    conteudo.addEventListener('scroll', ShareFunctions.headerScroll)
  },
  methods: {
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.col40ponto4 img {
  width: 100%;
  max-width: 481px;
}

.sectionTitle {
    font-size: 20px;
    line-height: 25px;
    margin-top: 35px;
    margin-bottom: 15px;
}

.listItems {
    list-style: none;
    padding-left: 1.5rem;
}
li {
    display: list-item;
    unicode-bidi: isolate;
    list-style: none;
}

.listItems li {
    position: relative;
    margin-bottom: 1rem;
}

.listItems li::before {
    content: "•";
    color: #178dcc;
    position: absolute;
    left: -1rem;
}

.h4Destaque {
  max-width: 586px;
  margin-top: 140px;
}


@media screen and (max-width: 800px) {
  .col40ponto4 img {
    margin-bottom: 32px;
  }
  .h4Destaque {
    max-width: unset;
    margin-top: 40px;
    margin-bottom: 40px;
  }
}
</style>
